import Marquee3k from 'marquee3000';
Marquee3k.init();